// extracted by mini-css-extract-plugin
module.exports = {"aplixlogoRoot":"aplixlogoRoot--e36a0","aplixlogoImage":"aplixlogoImage--439b0"};